import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/_settings/user/$userId/admin',
)({
  component: RouteComponent,
  loader: async ({ context }) => {
    const { authState, isOrgAdmin } = context

    if (!isOrgAdmin) {
      throw redirect({
        to: '/user/$userId',
        params: { userId: authState!.uid },
      })
    }
  },
})

function RouteComponent() {
  return <Outlet />
}
